import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VacationKind } from '@work4all/models/lib/Classes/VacationKind.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const LOOKUP_DATA: VacationKind = {
  id: null,
  name: null,
  color: null,
  demandReducing: null,
  shortTimeWork: null,
  showAs: null,
  timeCompensation: null,
};

const newEntryMandatoryFields: (keyof VacationKind)[] = ['name'];

export const VacationKindTable = () => {
  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<VacationKind>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 300,
        type: 'text',
        resizable: false,
      },
      {
        Header: t('COMMON.VACATIONKIND.DEMAND_REDUCING'),
        accessor: 'demandReducing',
        width: 100,
        type: 'checkbox',
        resizable: false,
      },
      {
        Header: t('COMMON.COLOR'),
        accessor: 'color',
        width: 100,
        type: 'color',
        resizable: false,
      },
      {
        Header: t('COMMON.DEMAND_REDUCING.TIME_COMPENSATION'),
        accessor: 'timeCompensation',
        width: 100,
        type: 'checkbox',
        resizable: false,
      },
      {
        Header: t('COMMON.DEMAND_REDUCING.SHOW_AS'),
        accessor: 'showAs',
        type: 'text',
        width: 100,
        resizable: false,
      },
      {
        Header: t('COMMON.DEMAND_REDUCING.SHORT_TIME_WORK'),
        accessor: 'shortTimeWork',
        width: 100,
        type: 'checkbox',
        resizable: false,
      },
    ],
    [t]
  );

  return (
    <EditableEntityTable<VacationKind>
      columns={cols}
      dataFields={LOOKUP_DATA}
      entity={Entities.vacationKind}
      idType="number"
      sortByField="name"
      newEntryMandatoryFields={newEntryMandatoryFields}
      enableDelete
      deleteEntityType={Entities.lookUp}
      dataProviderProps={{
        completeDataResponse: true,
      }}
    />
  );
};
